import axios from 'axios'
import API_URL from '@/router/api'

export const getListCoupons = (ctx, params) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.coupons.findMany

        axios.get(url, {params}).then(res => {
            resolve(res)
        })
        .catch(err => {
            reject(err)
        })
    })
}

export const create = (ctx, form) => {
    return new Promise((resolve, reject) => {

        axios.post(API_URL.campaigns.createCampaign, form)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const update = (ctx, { id, form }) => {

    return new Promise((resolve, reject) => {

        const url = API_URL.campaigns.updateCampaign.replace(/__id__/, id)

        axios.put(url, form)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const updateStatus = (ctx, { id, form }) => {

    return new Promise((resolve, reject) => {

        const url = API_URL.campaigns.updateCampaignStatus.replace(/__id__/, id)

        axios.put(url, form)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}


export const deleteCampaign = (ctx, {id}) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.campaigns.deleteCampaign.replace(/__id__/, id)

        axios.delete(url).then(res => {
            resolve(res)
        })
        .catch(err => {
            reject(err)
        })
    })
}


export const getListCampaigns = (ctx, params) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.campaigns.findMany

        axios.get(url, {params}).then(res => {
            resolve(res)
        })
        .catch(err => {
            reject(err)
        })
    })
}

export const findById = (ctx, id) => {

    return new Promise((resolve, reject) => {
        const url = API_URL.campaigns.findById.replace(/__id__/, id)

        axios.get(url).then(res => {
            resolve(res)
        })
        .catch(err => {
            reject(err)
        })
    })
}

export const updateStatusAll = (ctx, { form }) => {

    return new Promise((resolve, reject) => {

        const url = API_URL.campaigns.updateCampaignStatusAll

        axios.put(url, form)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
